import { Heading } from '@cinch-labs/design-system'
import { undashifyAndCapitalise } from '@cinch-labs/shared-util'
import type { ArticlePreview } from '@cinch-nx/landing-ui-articles'
import { formatFullSlugToPath } from '@cinch-nx/landing-ui-articles'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import Link from 'next/link'

import { ArticlePreviewCard } from '../article-preview-card/article-preview-card'
import styles from './articles-preview.module.css'

export interface ArticlesPreviewProps {
  slug: string
  articles: ArticlePreview[]
}

export const ArticlesPreview: React.FC<ArticlesPreviewProps> = ({
  slug,
  articles,
}) => {
  const { trackEvent } = useAnalytics((state) => ({
    trackEvent: state.trackEvent,
  }))

  const handleGuideLinkClick = () => {
    trackEvent({
      eventName: undashifyAndCapitalise(slug),
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'link',
          label: 'guides',
          action: EventNames.click,
        },
      },
    })
  }

  return (
    <section
      className={styles['container']}
      data-testid={`feature-article-${slug}`}
    >
      <Heading element="h2" className={styles['title']}>
        {undashifyAndCapitalise(slug)}
      </Heading>

      <ul className={styles['articlesList']}>
        <ArticlePreviewCard
          key={articles[0].content._uid}
          title={articles[0].content.title}
          path={formatFullSlugToPath(articles[0].full_slug)}
          image={articles[0].content.image}
          date={articles[0].first_published_at ?? ''}
          featured
        />
        <li>
          <ul>
            {articles.slice(1).map((article) => (
              <ArticlePreviewCard
                key={article.content._uid}
                title={article.content.title}
                path={formatFullSlugToPath(article.full_slug)}
                image={article.content.image}
                date={article.first_published_at ?? ''}
              />
            ))}
            <li
              className={styles['listLink']}
              data-testid={`article-sub-hub-link-${slug}`}
            >
              <Link href={`/guides/${slug}`} passHref legacyBehavior>
                <a
                  className={styles['link']}
                  href="/guides"
                  onClick={handleGuideLinkClick}
                >
                  <span className={styles['linkTitle']}>
                    All {slug.replace(/-/g, ' ')} articles
                  </span>
                  →
                </a>
              </Link>
            </li>
          </ul>
        </li>
      </ul>
    </section>
  )
}
